document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('countdown-shopify');
  if (!el) return;
  if (typeof luxon === 'undefined') return;

  const { DateTime } = luxon;
  const dayMonth = el.dataset.date;
  const timeZone = el.dataset.timezone;
  if (!dayMonth || !timeZone) return;

  const now = DateTime.now().setZone(timeZone);
  const countdownTarget = DateTime.fromFormat(`${dayMonth}/${now.year}`, 'MM/dd/yyyy', { zone: timeZone });

  const interval = setInterval(() => {
    const diff = countdownTarget.diff(DateTime.now().setZone(timeZone), ['days', 'hours', 'minutes', 'seconds']).toObject();

    if (diff.seconds < 0) {
      document.getElementById('countdown').style.display = 'none';
      document.getElementById('content').style.display = 'block';
      clearInterval(interval);
      return;
    }

    document.getElementById('days').innerText = Math.floor(diff.days);
    document.getElementById('hours').innerText = Math.floor(diff.hours);
    document.getElementById('minutes').innerText = Math.floor(diff.minutes);
    document.getElementById('seconds').innerText = Math.floor(diff.seconds);
  }, 1000);
});
